import { useState } from 'react';
import { Play, X } from 'lucide-react';
import { Dialog, DialogContent } from '@/components/ui/dialog';

const VIDEO_ID = 'qGKHHMjDTwU';
const THUMBNAIL_URL = `https://img.youtube.com/vi/${VIDEO_ID}/sddefault.jpg`;
const EMBED_URL = `https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&modestbranding=1&controls=0&showinfo=0&rel=0&iv_load_policy=3&disablekb=1&fs=0&playsinline=1`;

interface VSLPlayerProps {
  inline?: boolean;
}

export function VSLPlayer({ inline = true }: VSLPlayerProps) {
  const [isPlaying, setIsPlaying] = useState(false);

  if (!inline) return null;

  return (
    <button
      type="button"
      aria-label="Reproduzir vídeo de apresentação"
      className="relative aspect-video w-full rounded-2xl overflow-hidden glass-card cursor-pointer group block text-left p-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      onClick={() => !isPlaying && setIsPlaying(true)}
    >
      {isPlaying ? (
        <iframe
          src={EMBED_URL}
          allow="autoplay; encrypted-media"
          allowFullScreen
          className="absolute inset-0 w-full h-full border-0"
          title="Vídeo de apresentação PromptCodex"
        />
      ) : (
        <>
          <img
            src={THUMBNAIL_URL}
            alt="Capa do vídeo de apresentação do PromptCodex"
            width={640}
            height={360}
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <div className="absolute inset-0 bg-background/30 flex items-center justify-center transition-colors group-hover:bg-background/20">
            <div className="w-20 h-20 rounded-full gradient-primary flex items-center justify-center glow-primary transition-transform group-hover:scale-110">
              <Play className="w-8 h-8 text-primary-foreground ml-1" aria-hidden="true" />
            </div>
          </div>
        </>
      )}
    </button>
  );
}

export function VSLDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[95vw] p-0 border-none bg-transparent shadow-none [&>button]:hidden">
        <button
          type="button"
          aria-label="Fechar vídeo"
          onClick={() => onOpenChange(false)}
          className="absolute -top-12 right-0 z-50 p-2 -m-2 text-foreground/80 hover:text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded"
        >
          <X className="w-6 h-6" aria-hidden="true" />
        </button>
        <div className="relative aspect-video w-full rounded-2xl overflow-hidden">
          {open && (
            <iframe
              src={EMBED_URL}
              allow="autoplay; encrypted-media"
              allowFullScreen
              className="absolute inset-0 w-full h-full border-0"
              title="VSL"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
